import axios from 'axios';
import { purgeStoredState } from 'redux-persist';
import { asyncSessionStorage } from 'redux-persist/storages';
import _find from 'lodash/find';
import * as types from '../constants/ActionTypes';
import { setURLQuery, isLoggedIn, delayChecker } from '../../lib/page';
import { chatType } from '../constants/UtilVariables';
import { trackPage } from '../../lib/analytics-helper';

// TODO move some of this logic into Page.js (after moratorium) - START
const wasChatBotClicked = (window.sessionStorage && window.sessionStorage.getItem('chatBotClicked') === 'true');
const wasLiveChatClicked = (window.sessionStorage && window.sessionStorage.getItem('liveChatClicked') === 'true');
const CHANNEL_CHATBOT = chatType.chatBot;
const CHANNEL_LIVECHAT = chatType.liveChat;
// TODO move some of this logic into Page.js (after moratorium) - END

function requestChatEligibility() {
  return { type: types.REQUEST_CHAT_ELIGIBILITY };
}

function receiveChatEligibilityError() {
  return {
    type: types.RECEIVE_CHAT_ERROR,
    payload: undefined,
  };
}

function receiveChatEligibilityResponse(responseData) {
  return {
    type: types.RECEIVE_CHAT_RESPONSE,
    payload: {
      isChatEnabled: responseData.chatEnabled,
      waitTime: responseData.ewt,
    },
  };
}

function purgeStorageAsync() {
  return purgeStoredState({ storage: asyncSessionStorage })
    .then(() => {})
    .catch(() => {});
}

function resetClicksOnChatChatBotAndPurgeStorageAsync(fromChannel) {
  if (fromChannel === CHANNEL_CHATBOT && wasChatBotClicked) {
    sessionStorage.setItem('chatBotClicked', 'false');
    purgeStorageAsync();
  }

  if (fromChannel === CHANNEL_LIVECHAT && wasLiveChatClicked) {
    sessionStorage.setItem('liveChatClicked', 'false');
    purgeStorageAsync();
  }
}

/**
 * Will set timeout for chatEligibility API based on stage/local or production
 * @returns {number}
 */
function timeForChatExecution() {
  const hostName = window.location.hostname;
  if (typeof (hostName) === 'string' && (hostName.includes('localhost') || hostName.includes('.qa.paypal.com'))) {
    return 0;
  }
  return 3000;
}

function chatEligibilityCheck(topicId, fromChannel, showChat, reject) {
  return (dispatch) => {
    dispatch(requestChatEligibility());
    let eligibilityURL = `/smarthelp/node-chat/chat/eligibility?topicName=${topicId}`;

    // Add loggedOut query for logout Live chat options checker
    if (!isLoggedIn()) {
      eligibilityURL = setURLQuery(eligibilityURL, 'loggedOut', true);
    }

    axios({
      method: 'get',
      url: eligibilityURL,
      timeout: timeForChatExecution(),
    })
      .then((response) => {
        if (fromChannel === chatType.liveChat) {
          if (response.data.chatEnabled) {
            dispatch(showChat({ topicRefId: topicId }, fromChannel)); // Show Live Chat
          } else {
            dispatch(reject()); // Show non-eligibility page
          }
        }
        dispatch(receiveChatEligibilityResponse(response.data));
        resetClicksOnChatChatBotAndPurgeStorageAsync(fromChannel);
      })
      .catch((err) => {
        // Timeout errors have ECONNABORTED as code
        if (err.code === 'ECONNABORTED' && err.message && err.message.indexOf('timeout') >= 0) {
          trackPage({ id: 'contactUsChatTimeoutPage', link: 'chat-timeout' });
        }
        if (fromChannel === chatType.liveChat) {
          dispatch(reject());
        }
        dispatch(receiveChatEligibilityError());
        resetClicksOnChatChatBotAndPurgeStorageAsync(fromChannel);
      });
  };
}

function fetchChatEligibility(topicId, fromChannel, showChat, reject) {
  return (dispatch) => {
    axios.get('/smarthelp/chat-options-sac?keys=Chat').then((response) => {
      if (response && response.data && response.data.chatSettings && Array.isArray(response.data.chatSettings.configs) &&
         response.data.chatSettings.configs[0].value === 'enabled') {
        dispatch(chatEligibilityCheck(topicId, fromChannel, showChat, reject));
      } else {
        dispatch(chatEligibilityCheck(topicId, fromChannel, showChat, reject));
      }
    }).catch(() => {
      dispatch(chatEligibilityCheck(topicId, fromChannel));
    });
  };
}

// Lexa Chat Eligibility checker; get Chat eligibility from IDI availability_decision
function lexaChatEligibilityChecker(topicId, fromChannel, showChat, reject) {
  return (dispatch, getState) => {
    const callback = (params) => {
      if (!params) {
        dispatch(reject()); // Show error message, if the Chat eligibilty is failed after logged in
      }
      dispatch(showChat({ topicRefId: topicId }, fromChannel));
    };

    // return true for chat eligibilty, when there is Chat option and availability_decision is equal to `AVAILABLE` in the IDI channels
    const checker = state => () => {
      if (!state.contactChannels || !state.contactChannels.IDIIsLoaded || !Array.isArray(state.contactChannels.IDIAvailability)) {
        return false;
      }
      const chatDecision = _find(state.contactChannels.IDIAvailability, decision => decision.name === 'CHAT');
      return chatDecision && chatDecision.availability_decision === 'AVAILABLE';
    };

    delayChecker(checker(getState()), 10, callback); // Wait IDI contact options to finish loading
  };
}

module.exports = {
  lexaChatEligibilityChecker,
  fetchChatEligibility,
};
